import { createActionCreator } from 'deox';

import { TLicensePriceResponse } from '@/services/api/company';

// CONSTANTS

export enum EGetLicensePriceAction {
  GET_LICENSE_PRICE = 'GET_LICENSE_PRICE',
  GET_LICENSE_PRICE_REQUEST = 'GET_LICENSE_PRICE_REQUEST',
  GET_LICENSE_PRICE_SUCCESS = 'GET_LICENSE_PRICE_SUCCESS',
  GET_LICENSE_PRICE_FAILED = 'GET_LICENSE_PRICE_FAILED',
}

// TYPES

export type TGetLicensePriceRequest = {
  type: EGetLicensePriceAction.GET_LICENSE_PRICE_REQUEST;
  payload: {
    successCallback?: (response: TLicensePriceResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TGetLicensePriceSuccess = {
  type: EGetLicensePriceAction.GET_LICENSE_PRICE_SUCCESS;
  payload: { response: TLicensePriceResponse };
};

export type TGetLicensePriceFailed = { type: EGetLicensePriceAction.GET_LICENSE_PRICE_FAILED };

// FUNCTION

export const getLicensePriceAction = {
  request: createActionCreator(
    EGetLicensePriceAction.GET_LICENSE_PRICE_REQUEST,
    (resolve) =>
      (
        successCallback?: (response: TLicensePriceResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TGetLicensePriceRequest =>
        resolve({ successCallback, failedCallback }),
  ),
  success: createActionCreator(
    EGetLicensePriceAction.GET_LICENSE_PRICE_SUCCESS,
    (resolve) =>
      (response: TLicensePriceResponse): TGetLicensePriceSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    EGetLicensePriceAction.GET_LICENSE_PRICE_FAILED,
    (resolve) =>
      (error: any): TGetLicensePriceFailed =>
        resolve({ error }),
  ),
};
